require('../css/main.scss');

import App from './controllers/App';

new App();


// WEBPACK FOOTER //
// ./src/js/main.js